import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { DynamoDbAiAccesses } from "./accesses.ts";
import { DynamoDbAiComponents } from "./components.ts";

const DynamoDbAiFilters = {
  account: { keys: ["id"] },
  level: { keys: ["name"] },
  region: { keys: ["name"] },
  table: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type DynamoDbAiFilters = typeof DynamoDbAiFilters;

export const DynamoDbAiRegistration = Registration({
  accesses: DynamoDbAiAccesses,
  category: "resource",
  components: DynamoDbAiComponents,
  docs: {},
  filters: DynamoDbAiFilters,
  itemKind: "account",
  label: "DynamoDB (AI)",
  logoUrl:
    "https://awsfundamentals.com/assets/aws-icons/Arch_Amazon-DynamoDB_64.svg",
  maturity: "beta",
  // The agent's request routes by the CLI's resource-type positional, so
  // `p0 request dynamodb-ai table …` only works if this is requestable.
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("dynamodb-ai", DynamoDbAiRegistration);
